import { LoadingCompletedIcon } from '~/components/atoms/LoadingCompletedIcon'
import { LoadingFinanceSimulationContent } from '~/components/molecules/LoadingFinanceSimulationContent'
import { SpinnerLoading } from '~/styles/global'
import { useLoadingFinanceSimulation } from './hooks'

export const LoadingFinanceSimulation = () => {
  const { isLoadingMessage, firstName } = useLoadingFinanceSimulation()

  return (
    <>
      {isLoadingMessage ? (
        <LoadingFinanceSimulationContent
          icon={<SpinnerLoading />}
          text={firstName && `${firstName}, aguarde enquanto preparamos as melhores condições de pagamento para você... ⏳`}
        />
      ) : (
        <LoadingFinanceSimulationContent icon={<LoadingCompletedIcon />} text={'Pronto! Encontramos as melhores condições'} />
      )}
    </>
  )
}
